"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTranslatedString = getTranslatedString;
exports.getDomainName = getDomainName;
exports.findMatchingPrivacyItem = findMatchingPrivacyItem;
exports.itemShouldBeVisible = itemShouldBeVisible;
exports.itemShouldBeEditable = itemShouldBeEditable;
exports.sortBasketItemsAndGroups = sortBasketItemsAndGroups;

/**
 * replace "BUNDLE OFFER" string with i18n text. renamed from `correctItemLabel`.
 * @param {string} str - static string to be replaced by translated string, if applicable (e.g., basket item label)
 * @param {object} language - language data including `language.domain.bundleOffer` string
 * @returns {string} updated string
 */
function getTranslatedString(str, language) {
  if (str && str.endsWith("BUNDLE OFFER")) {
    return str.replace("BUNDLE OFFER", language.domain.bundleOffer);
  }
  return str;
}

/**
 * get domain name from a basket item
 * @param {object} basketItem - basket item json
 * @returns {string} domain name
 */
function getDomainName(basketItem) {
  if (basketItem.metadata && basketItem.metadata.domains && basketItem.metadata.domains.length > 0) {
    return basketItem.metadata.domains[0].domain;
  }
  return null;
}

/**
 * return a matching privacy basket item for the basket item provided, if it exists. renamed from `getPrivacyItem`
 * @param {object} basketItem - basket item json
 * @param {array} privacyItems - array of privacy basket items
 * @returns {object} privacy basket item
 */
function findMatchingPrivacyItem(basketItem, privacyItems) {
  if (privacyItems && basketItem.pfid !== 7001) {
    var domainName = getDomainName(basketItem);
    if (domainName) {
      for (var i = privacyItems.length; i--;) {
        var privacyDomain = getDomainName(privacyItems[i]);
        if (privacyDomain === domainName) {
          return privacyItems[i];
        }
      }
    }
  }
  return null;
}

/**
 * determine if the basket item should be displayed based on whether it's a privacy item (7001)
 * @param {object} basketItem - basket item json
 * @param {array} domainItems - array of domain basket items
 * @returns {bool} basket item should be visible
 */
function itemShouldBeVisible(basketItem, domainItems) {
  if (domainItems && basketItem.pfid === 7001) {
    var privacyDomain = getDomainName(basketItem);
    if (privacyDomain) {
      for (var i = domainItems.length; i--;) {
        var domainName = getDomainName(domainItems[i]);
        if (privacyDomain === domainName) {
          return false;
        }
      }
    }
  }
  return true;
}

/**
 * determine if the basket item should be editable
 * @param {object} basketItem - basket item json
 * @returns {bool} basket item should be editable
 */
function itemShouldBeEditable(basketItem) {
  return Boolean(basketItem.crossSells && basketItem.crossSells.length > 0 || basketItem.periodOptions && basketItem.periodOptions.length > 0 || basketItem.quantityOptions);
}

function updateDomainPrivacyLists(item, privacyItems, domainItems) {
  if (item.pfid === 7001) {
    privacyItems.push(item);
  } else if (getDomainName(item)) {
    domainItems.push(item);
  }
}

/**
 * mix and sort the basket items and groups in descending order (most recently added items on top).
 * @param {object} basketJson - basket json
 * @param {bool} lastAddedFirst - sort the last added item to the top
 * @returns {array} array of basket items and groups
 */
function sortBasketItemsAndGroups(basketJson) {
  var lastAddedFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var basketItems = [],
      privacyItems = [],
      domainItems = [];
  var groups = basketJson.groups,
      items = basketJson.items;


  if (items && items.length > 0) {
    for (var i = 0, len = items.length; i < len; i++) {
      var item = items[i];
      basketItems.push({
        basketItem: item,
        basketItemGroup: null,
        displayOrder: item.displayOrder
      });
      updateDomainPrivacyLists(item, privacyItems, domainItems);
    }
  }

  if (groups) {
    for (var _i = 0, _len = groups.length; _i < _len; _i++) {
      basketItems.push({
        basketItem: null,
        basketItemGroup: groups[_i],
        displayOrder: groups[_i].items[0].displayOrder
      });

      var groupItems = groups[_i].items;
      for (var j = 0, leng = groupItems.length; j < leng; j++) {
        updateDomainPrivacyLists(groupItems[j], privacyItems, domainItems);
      }
    }
  }

  basketItems.sort(function (a, b) {
    return lastAddedFirst ? parseFloat(b.displayOrder) - parseFloat(a.displayOrder) : parseFloat(a.displayOrder) - parseFloat(b.displayOrder);
  });

  return { basketItems: basketItems, privacyItems: privacyItems, domainItems: domainItems };
}